import Vue from 'vue'
export const EventBus = new Vue()
import ElementUI, { Loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { detectZoom } from '@/utils/detectZoom.js'
const m = detectZoom()
// document.body.style.zoom = 100 / Number(m)
import App from './App.vue'
import './assets/css/index.css'
import './styles/index.less'
import './plugins/element.js'
import './styles/iconfont.js'
// api
import Api from '@/api'
// Loading
//富文本
import VueQuillEditor from 'vue-quill-editor'
//  require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import global_ from '../config/global.js'
Vue.prototype.GLOBAL = global_
Vue.config.productionTip = false
import router from '@/router/index.js'
import { store } from '@/store/store.js'
Vue.use(ElementUI)
//富文本编辑器
Vue.use(VueQuillEditor)
Vue.prototype.Api = Api
import md5 from 'js-md5' //引入
Vue.prototype.$md5 = md5 //定义全局变量
// 跳转后返回顶部
router.beforeEach((to, from, next) => {
  if (from.path == '/home') {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
  } else {
    next()
  }
})

import * as Echarts from 'echarts'
Vue.prototype.$echarts = Echarts
Vue.prototype.$useEcharts = function(id, option) {
  let myChart = this.$echarts.init(document.getElementById(id), null, {
    locale: 'ZH'
  })
  myChart.clear()
  myChart.setOption(option)
  window.addEventListener('resize', myChart.resize)
  return myChart
}
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
